import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {SystemColour} from '../../utils/colour.types'

@Component({
  selector: 'cft-sidenav-item',
  templateUrl: './sidenav-item.component.html',
  styleUrls: ['./sidenav-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavItemComponent {
  @Input()
  readonly icon!: {name: string; collection: string} | IconDefinition

  @Input()
  readonly name!: string

  @Input()
  readonly active: boolean = false

  @Input()
  readonly counter?: number

  @Input()
  readonly link?: string

  @Input()
  readonly chip?: Chip | null

  isOpen = true

  constructor(private readonly cdr: ChangeDetectorRef) {}

  get dynamicIcon(): {name: string; collection: string} | undefined {
    if (this.icon?.['name'] && this.icon?.['collection']) {
      return this.icon as {name: string; collection: string}
    }
  }

  get faIcon(): IconDefinition | undefined {
    if (this.icon?.['icon']) {
      return this.icon as IconDefinition
    }
  }

  close() {
    this.isOpen = false
    this.cdr.detectChanges()
  }

  open() {
    this.isOpen = true
    this.cdr.detectChanges()
  }
}

export interface Chip {
  text: string
  colour: SystemColour
}
